import React from 'react';
import { useContentViewer } from './hooks/useContentViewer';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Navigation from './components/Navigation';
import { default as MarkdownViewer } from '../LoadProcessedJson';

const ContentViewer = () => {
  const {
    sections,
    currentSection,
    darkMode,
    setDarkMode,
    handleMarkComplete,
    goToPreviousSection,
    resetProgress,
    calculateProgress,
    readSections,
    setCurrentSection,
    handleContinue,
  } = useContentViewer();

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar 
        sections={sections}
        currentSection={currentSection}
        readSections={readSections}
        setCurrentSection={setCurrentSection}
        progress={calculateProgress()}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header 
          title={sections[currentSection]?.title || 'Content'}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          onResetProgress={resetProgress}
        />
        <main className="flex-1 overflow-y-auto p-6 bg-gray-50 dark:bg-gray-900">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg">
              <div className="p-8">
                <div className="prose dark:prose-invert max-w-none
                  prose-headings:font-display
                  prose-h1:text-4xl prose-h1:font-extrabold prose-h1:tracking-tight
                  prose-h2:text-3xl prose-h2:font-bold prose-h2:tracking-normal
                  prose-h3:text-2xl prose-h3:font-semibold
                  prose-p:text-gray-600 dark:prose-p:text-gray-300
                  prose-li:text-gray-600 dark:prose-li:text-gray-300
                  prose-strong:text-gray-900 dark:prose-strong:text-white
                  prose-code:bg-gray-100 dark:prose-code:bg-gray-700
                  prose-pre:bg-gray-800 dark:prose-pre:bg-gray-900
                  prose-blockquote:border-l-4 prose-blockquote:border-gray-300 dark:prose-blockquote:border-gray-600
                  prose-a:text-blue-600 dark:prose-a:text-blue-400
                  prose-img:rounded-lg prose-img:shadow-md">
                  <MarkdownViewer sections={[sections[currentSection]]} />
                </div>
              </div>
            </div>
            <Navigation 
              currentSection={currentSection}
              totalSections={sections.length}
              readSections={readSections}
              onPrevious={goToPreviousSection}
              onMarkComplete={handleMarkComplete}
            />
          </div>
        </main>
      </div>
    </div>
  );
};

export default ContentViewer;
